module.exports = __webpack_public_path__ + "static/media/YM23_2.7d454b03.jpg";